<template>
  <div class="modifyName">
    <div class="weui-cells weui-cells_form" style="margin-top: 0;">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <input type="text" id="js_input" class="weui-input" placeholder="请输入名字" v-model="accountData.nickName" maxlength="20">
        </div>
      </div>
    </div>
    <div class="weui-form__opr-area" style="margin-top: 20px;">
      <a class="weui-btn weui-btn_primary" :class="{'weui-btn_disabled' : !accountData.nickName}" href="javascript:" style="width: 90%;" @click="updateNickName">确定</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modifyName',
  data () {
    return {
      accountData: {
        nickName: ''
      }
    }
  },
  activated () {
    this.getMyAccount()
  },
  methods: {
    getMyAccount () { // 查询用户信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            self.accountData = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateNickName () { // 提交昵称
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/update/avatar',
          body: {
            nickName: self.accountData.nickName
          }
        })
        .then(res => {
          if (res.success) {
            // 成功后返回
            self.$router.back()
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/mine/modify/name.vue